import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import InsertFragmentLinkCommand from './insertfragmentlinkcommand';

export default class InsertFragmentLinkUI extends Plugin {

  init() {
    this.editor.commands.add('insertfragmentlink', new InsertFragmentLinkCommand(this.editor));
  }
}